import React from "react";
import styles from "../styles/platos.module.css";

export default function PlatosFiltersBar({ q, onQ, onCreate }) {
    return (
        <div className={`${styles.card} ${styles["filters-row"]}`}>
            <input
                className={styles.input}
                placeholder="Buscar por nombre, descripción o alérgeno…"
                value={q}
                onChange={(e) => onQ(e.target.value)}
            />
            <div className={styles["actions-row"]}>
                <button type="button" className={`${styles.btn} ${styles.primary}`} onClick={onCreate}>
                    + Nuevo plato
                </button>
            </div>
        </div>
    );
}
